module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/src/app/pages/pages.component.html
// module id = ../../../../../src/app/pages/pages.component.html
// module chunks = 4